var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-content',{attrs:{"id":"page-wrap"}},[_c('HeroHeader',{attrs:{"isExperienceHeader":true}}),_vm._t("default")],2),_c('AppFooter',{attrs:{"isExperienceFooter":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }